import { createReducer } from '@reduxjs/toolkit';
import unionBy from 'lodash/unionBy';
import sortBy from 'lodash/sortBy';

import { Nullable } from 'modules/types/common';

import { TimeSlot } from 'store/booking/types';
import * as actions from 'store/booking/actions';

export type TimeSlotsState = Readonly<{
  isFetching: boolean;
  error: Nullable<Error>;
  data: TimeSlot[];
}>;

export const timeSlotsInitialState: TimeSlotsState = {
  isFetching: false,
  error: null,
  data: []
};

export const timeSlotsReducer = createReducer(timeSlotsInitialState, {
  [actions.GET_LOCATION_TIME_SLOTS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_LOCATION_TIME_SLOTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.GET_LOCATION_TIME_SLOTS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    const combinedSlots = unionBy(action.payload, state.data, 'id');
    state.data = sortBy(combinedSlots, ['datetime']);
  },
  [actions.SET_INITIAL_TIME_SLOTS]: (state, action) => {
    state.data = action.payload;
  },
  [actions.CLEAR_LOCATION_TIME_SLOTS]: state => {
    state.data = timeSlotsInitialState.data;
  }
});

export default timeSlotsReducer;
